import React from 'react';
import PropTypes from 'prop-types';
import { message } from 'antd';
import { CopyOutlined } from '@ant-design/icons';
import { useMaiaT } from '$app/i18n/useMaiaT';
import { buildGarageWebpageDisplayUrl, buildGarageWebpageUrl } from '../../../utils/garageWebpage';
import { WebpageContainer, WebpageLabel, WebpageLinkRow, WebpageLink } from './styled';

export function GarageWebpageLink({ segment, slug }) {
  const t = useMaiaT();
  const displayUrl = buildGarageWebpageDisplayUrl(segment, slug);
  const fullUrl = buildGarageWebpageUrl(segment, slug);

  if (!displayUrl || !fullUrl) {
    return null;
  }

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(fullUrl);
      message.success(t('maia.garageInfo.linkCopied', 'Link copied'));
    } catch {
      message.error(t('maia.garageInfo.linkCopyFailed', 'Failed to copy link'));
    }
  };

  return (
    <WebpageContainer>
      <WebpageLabel>{t('maia.garageInfo.garageWebpage', 'Your garage webpage')}</WebpageLabel>
      <WebpageLinkRow data-testid="garage-webpage-link-row">
        <CopyOutlined onClick={handleCopy} aria-label={t('maia.garageInfo.copyGarageWebpage', 'Copy garage webpage link')} />
        <WebpageLink href={fullUrl} target="_blank" rel="noopener noreferrer">
          {displayUrl}
        </WebpageLink>
      </WebpageLinkRow>
    </WebpageContainer>
  );
}

GarageWebpageLink.propTypes = {
  segment: PropTypes.string.isRequired,
  slug: PropTypes.string.isRequired,
};

export default GarageWebpageLink;
